module.exports = __webpack_public_path__ + "static/media/blank.72a93121.svg";